/* Package JSON Import will be here */
import React from "react";
import { Badge } from "antd";
/* Package JSON Import will be here */
import Constants from "utilities/appConstants";

const OfferRibbon = (props: any) => {
  debugger;
  /* For exchange return page product card, the offer label and free label will not be applicable*/
  if (props.product.IsFree && props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST) {
    return (
      <Badge.Ribbon color="#ff6b35" placement="start" text={props.translate("products.productLabel.free")}>
        {props.children}
      </Badge.Ribbon>
    );
  }
  else if (
    (((props.product.SchemeAmount > 0 || props.product.SchemeList.length > 0) &&
      (props.product.DiscountList.length > 0 || props.product.DiscAmount > 0)) ||
      (props.product.SchemeAmount > 0 || props.product.SchemeList.length > 0)) &&
    props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST &&
    props.pageType !== Constants.ORDER_SUMMARY_ITEM
  ) {
    return (
      <Badge.Ribbon color="#ff6b35" placement="start" text={props.translate("products.productLabel.promotion")}>
        {props.children}
      </Badge.Ribbon>
    );
  }
  else if ((props.product.DiscountList.length > 0 || props.product.DiscAmount > 0) && (props.pageType !== Constants.EXCHANGE_RETURN_PRODUCT_LIST && props.pageType !== Constants.ORDER_SUMMARY_ITEM)) {
    return (
      <Badge.Ribbon color="#4CAF50" placement="start" text={props.translate("products.productLabel.discountRibbon")}>
        {props.children}
      </Badge.Ribbon>
    );
  }
  else {
    return (props.children);
  }
}

export default OfferRibbon;